import { Injectable, ElementRef } from '@angular/core';
import { coordinates, AuthMapService } from '../services/auth-map.service';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import Modify from 'ol/interaction/Modify';
import VectorLayer from 'ol/layer/Vector';
import Draw from 'ol/interaction/Draw';
import Polygon from 'ol/geom/Polygon';
import XYZ from 'ol/source/XYZ';
import VectorSource from 'ol/source/Vector';
import Cluster from 'ol/source/Cluster';
import { Circle as CircleStyle, Fill, Icon, Stroke, Style, Text } from 'ol/style.js';
import olFeature from 'ol/Feature.js';
import Point from 'ol/geom/Point.js';
import LineString from 'ol/geom/LineString.js';
import Circle from 'ol/geom/Circle.js';
import { Geometry } from 'ol/geom/Geometry';
import { containsExtent } from 'ol/extent';
import { fromLonLat } from 'ol/proj';
import { transform } from 'ol/proj';
import { toLonLat } from 'ol/proj';
import { createEmpty } from 'ol/extent';
import { extend } from 'ol/extent';
import Overlay from 'ol/Overlay';


import Attribution from 'ol/control/Attribution';
import { defaults as defaultControls } from 'ol/control';
import OSM from 'ol/source/OSM';
import { CommonService } from './common.service';
import { from } from 'rxjs';
import Feature from 'ol/Feature';


@Injectable({
  providedIn: 'root'
})
export class OpenlayerMapService implements AuthMapService {
  [x: string]: any;
  marker;
  gmarkers = [];
  polyLine;
  circle;
  lastinfowindow;
  map;
  lineString: any;


  constructor() { }
  createLine_stop(map: any, coordinates: any, color: any) {
    var points = [];
    for (var i = 0; i < coordinates.length; i++) {
      points.push(fromLonLat([
        coordinates[i]['lng'],
        coordinates[i]['lat']]));
      // this.addMarker(map,coordinates[i],null,'assets/icon/idle.png')
    }

    var thing = new LineString(points);

    var styles = new Style({
      stroke: new Stroke({
        color: color,
        width: 3
      })
    });

    var featurething = new olFeature({
      name: "lineString",
      geometry: thing,
      duration: 1200,
      delay: 10000
    });
    featurething.setStyle(styles);

    map.getLayers().item(2).getSource()
      .addFeature(featurething);
    //this.fitbounds(map, 2);
    //this.setCenter(map, coordinates);
  }
  loadMap(map: ElementRef, latLng: coordinates, cluster: boolean, clickEvent: any) {

    const vectorSource = new VectorSource({
      features: [],
      projection: 'EPSG:4326'
    })

    const clusterSource = new Cluster({
      distance: 40,
      source: vectorSource
    });

    const styleCache = {};
    let markerLayer;
    if (cluster) {
      //map.on('moveend', onMoveEnd);
      // map.on('movestart', function(event) {
      //   if(document.getElementById("markers").innerHTML == null)
      //   {
      //     markerContainer=document.getElementById("markers");
      //     markerContainer.innerHTML="";
      //   }
      // });
      let markerContainer: any;
      markerLayer = new VectorLayer({
        source: clusterSource,
        style: (feature) => {
          var size = feature.get('features').length;
          if (size == 1) {
            style = new Style({
              image: new Icon(({
                // anchor: [0.5, 1],
                // anchorXUnits: 'fraction',
                // anchorYUnits: 'fraction',
                // opacity: 1,
                // crossOrigin: 'anonymous',
                src: feature.values_.features[0]["values_"]["name"]["img"]
              }))
            });
            // var markerElement=document.createElement("div");
            // markerElement.className="overlays";
            // markerElement.id = feature.values_.features[0]["values_"]["name"]["plateNo"];
            // markerElement.innerHTML=feature.values_.features[0]["values_"]["name"]["plateNo"];
            // markerContainer.appendChild(markerElement);
            // var marker = new Overlay({
            //   position: fromLonLat([latLng.lng, latLng.lat]),
            //   positioning: 'center-center',
            //   element: markerElement,
            //   stopEvent: false
            // });
            // this.map.addOverlay(marker);
            // marker.setPosition(feature["values_"]["geometry"]["flatCoordinates"]);
            //feature.setId("singleMarker");
          } else {
            var style = styleCache[size];
            if (!style) {
              style = new Style({
                image: new CircleStyle({
                  radius: 15,
                  stroke: new Stroke({
                    color: '#32384b'
                  }),
                  fill: new Fill({
                    color: '#32384b'
                  }),
                  scale: 1
                }),

                text: new Text({
                  text: size.toString(),
                  fill: new Fill({
                    color: 'white'
                  }),
                  stroke: new Stroke({
                    color: 'white',
                    width: 1
                  }),
                })
              });
              styleCache[size] = style;
            }
          }
          return style;
        }
      });

    } else {
      markerLayer = new VectorLayer({
        source: vectorSource,
      });
    }
    markerLayer.setZIndex(3);



    // var baseLayer = commonFactory
    //     .layer(rootScopeVal.LoginDatas.mapView);


    const vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: [],
        projection: 'EPSG:4326',
        renderBuffer: 1e10
      }),
      style: new Style({
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.5)'
        }),
        stroke: new Stroke({
          color: 'green',
          width: 3
        })
      })
    });

    vectorLayer.setZIndex(2);

    const tileLayer = new TileLayer({
      source: new XYZ({
        // url: 'https://mt{0-3}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',

        // http://tile.apmkingstrack.com/hot/6/32/20.png
        //  url: 'http://tile.apmkingstrack.com/hot/{z}/{x}/{y}.png'
        // 'http://tile.thegoldenelement.com/hot/{z}/{x}/{y}.png'

        url: localStorage.mapDynamicUrl
      }),

      maxZoom: 20,
    });


    tileLayer.setVisible(true);




    const satelliteLayer = new TileLayer(
      {
        source: new XYZ(
          {
            url: 'http://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}'
          }),
      });
    satelliteLayer.setVisible(false);


    this.map = new Map({
      target: map,
      layers: [tileLayer, markerLayer, vectorLayer, satelliteLayer],
      view: new View({
        center: [latLng.lng, latLng.lat],
        zoom: 20,
        minZoom: 2.2,
      })
      // ,
      // controls : olControl.defaults({
      //   attribution : false
      // })
    });
    // console.log("this.map",this.map);

    if (clickEvent) {
      this.map.on('click', (evt) => {
        // console.log("evt",evt);

        var feature = this.map.getLayers().item(1).getSource().getClosestFeatureToCoordinate(evt.coordinate);
        // console.log("feature",feature);

        if (feature.values_.features.length > 1) {
          var extent = new createEmpty();
          feature.values_.features.forEach(function (feature) {
            new extend(extent, feature.getGeometry().getExtent());
          });
          this.map.getView().fit(extent, { duration: 2000 }); //duration: 2000
        } else {
          var fet = feature.get('features')[0]["values_"]["name"];
          clickEvent(fet);

          // document.getElementById('popup').innerHTML ="Plate Number : "
          // +fet.values_.name.plateNo
          // +"<br>"
          // + "Status " + fet.values_.name.status;
          // var popup = new Overlay({
          //   element: document.getElementById('popup')
          // });
          // popup.setPosition(evt.coordinate);
          // this.map.addOverlay(popup);
        }

      })
    }
    //   this.map.getView().on('change:zoom', (event) => {
    // });
    return this.map;
  }
  addMarker(map: any, latLng: coordinates, id: string, image: string) {
    const feature = new olFeature(
      {
        geometry: new Point(fromLonLat([latLng.lng, latLng.lat, 'EPSG:4326', 'EPSG:3857'])),
        name: 'contentString',
        title: 'fddf'
      });
    feature.setStyle([new Style({
      image: new Icon(({
        anchor: [0.5, 1],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        opacity: 1,
        crossOrigin: 'anonymous',
        src: image
      }))
    })]);

    if (id != null) {
      feature.setId(id);
    }
    this.map.getLayers().item(1).getSource().addFeature(feature);
    if (id != 'addGeoZone' && id != 'livetrack') {
      this.setCenter(this.map, latLng);
    }

  }

  addMarkerWithInfoWindow(map: any, latLng: coordinates, contentString: object, icon: string, label: string) {
    var feature = new olFeature({
      geometry: new Point(fromLonLat([latLng.lng, latLng.lat, 'EPSG:4326', 'EPSG:3857'])),
      name: contentString,
      title: 'lineString'
    });
    feature.setStyle(new Style({
      image: new Icon(({
        anchor: [0.5, 1],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        opacity: 1,
        crossOrigin: 'anonymous',
        src: icon,
        scale: 1
      })),
      text: new Text({
        text: label,
        font: 'bold 12px sans-serif',
        fill: new Fill({ color: '#000' }),
        stroke: new Stroke({ color: '#fff', width: 2 }),
        offsetY: -25 // adjust to move text above the icon
      })
    }));

    this.map.getLayers().item(1).getSource().addFeature(feature);
    // this.setCenter(map, latLng);
  }

  addClusteringMarkers(map: any, latLng: any, contentString: any) {

    var feature = new olFeature({
      geometry: new Point(fromLonLat([latLng.lng, latLng.lat, 'EPSG:4326', 'EPSG:3857'])),
      name: contentString,
      title: 'mapView',
      Style: {
        cursor: "pointer"
      }
    });
    map.getLayers().item(1).getSource().getSource().addFeature(feature);
  }

  clearClusteringMarkers(map: any, data: any) {
    for (var i = 0; i < data.length; i++) {
      map.getLayers().item(data[i]).getSource().getSource().clear();
    }
  }
  setCenter(map: any, latLng: coordinates) {
    map.getView().setCenter(
      fromLonLat([latLng.lng, latLng.lat]));
  }

  clearLayers(map: any, data: any) {
    for (var i = 0; i < data.length; i++) {
      map.getLayers().item(data[i]).getSource().clear();
    }
  }

  moveMarker(map: any, id: String, lon: number, lat: number, image: String, content: String, lineStringArray: coordinates[]) {
    if (map) {
      let feature = map.getLayers().item(1).getSource().getFeatureById(id);
      if (feature != null) {
        feature.setGeometry(new Point(fromLonLat([lon, lat])));
        feature.setStyle(new Style({
          image: new Icon(({
            anchor: [0.5, 1],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            opacity: 1,
            crossOrigin: 'anonymous',
            src: image
          }))
        }));


        const extent = map.getView().calculateExtent(map.getSize());
        //const extent2 = (feature.getGeometry())
        const extent2 = feature.getGeometry().getExtent();
        const containsMapWithinBounds = containsExtent(extent, extent2);
        if (!containsMapWithinBounds) {
          map.getView().setCenter(fromLonLat([lon, lat]));
        }
        if (id != "mapTabVehMoving")
          this.createLine(map, lineStringArray);
        // else {
        // this.addMarker(id, lon, lat);
        // }
      }
    }
  }

  createLine(map: any, coordinates: any) {
    var points = [];
    for (var i = 0; i < coordinates.length; i++) {
      points.push(fromLonLat([
        coordinates[i]['lng'],
        coordinates[i]['lat']]));
      // this.addMarker(map,coordinates[i],null,'assets/icon/idle.png')
    }

    var thing = new LineString(points);

    var styles = new Style({
      stroke: new Stroke({
        color: 'black',
        width: 3
      })
    });

    var featurething = new olFeature({
      name: "lineString",
      geometry: thing,
      duration: 1200,
      delay: 10000
    });
    featurething.setStyle(styles);

    map.getLayers().item(2).getSource()
      .addFeature(featurething);
    //this.fitbounds(map, 2);
    //this.setCenter(map, coordinates);
  }

  fitBounds(map: any, item: any) {
    var extent = map.getLayers().item(item).getSource()
      .getExtent();
    if (extent[0] != 'Infinity' && extent[0] != '-Infinity')
      map.getView().fit(extent, {
        duration: 2000, maxZoom: 20
      }); //duration: 1000,
  }

  fitBoundsForCluster(map: any) {
    var extent = map.getLayers().item(1).getSource().getSource()
      .getExtent();
    if (extent[0] != 'Infinity' && extent[0] != '-Infinity')
      map.getView().fit(extent, {
        duration: 2000, maxZoom: 20
      });// duration: 1000,
  }

  addLineString(map: any, latLng: coordinates) {
    this.lineString = new LineString([fromLonLat([latLng.lng, latLng.lat]), fromLonLat([48.234, 23.345])]);
    var styles = new Style({
      stroke: new Stroke({
        color: 'black',
        width: 3
      })
    });
    const featurething = new olFeature(this.lineString);
    // var featurething = new olFeature({
    //   name: "LineString",
    //   geometry: this.lineString
    // });
    featurething.setStyle(styles);

    map.getLayers().item(2).getSource()
      .addFeature(featurething);
  }

  createCircle(map: any, latLng: coordinates, range: number, type: any) {
    if (this.polyLine)
      map.removeInteraction(this.polyLine);
    var rootObj = this;
    let color = 'FF0000';
    this.circle = new Circle(fromLonLat([latLng.lng, latLng.lat]), range);
    if (type === 'Preferred' || type === "Prefered") {
      color = '1eb15d';
    }
    var styles = new Style({
      stroke: new Stroke({
        color: '#' + color,
        width: 3
      }),
      fill: new Fill({
        color: '#' + color + '50',
      })
    });
    const featurething = new olFeature(this.circle);
    featurething.setStyle(styles);
    featurething.setId('circleZone' + JSON.stringify(latLng));
    map.getLayers().item(2).getSource()
      .addFeature(featurething);
  }

  getRadius() {
    return this.circle.getRadius();
  }

  getCircleCenter() {
    return this.circle.getCenter();
  }

  setCircleRadius(range: any) {
    if (this.circle != undefined || this.circle != null || this.circle == '') {
      this.circle.setRadius(range);
    }
  }

  updateCircle(latLng: coordinates) {
    this.circle.setCenter(fromLonLat([latLng.lat, latLng.lng]));
    // this.setCenter(map, latLng);
    let latLngBounds = this.circle.getBounds();
    latLngBounds = latLngBounds.getNorthEast().lat() + ','
      + latLngBounds.getNorthEast().lng() + '|' + latLngBounds.getSouthWest().lat()
      + ',' + latLngBounds.getSouthWest().lng();
  }

  removeMarkersById(map: any, id: string) {
    var deleteId = map.getLayers().item(1).getSource().getFeatureById(id);
    if (deleteId != null) {
      map.getLayers().item(1).getSource().removeFeature(deleteId);
    }
  }
  //  loadPOCClusters(points: any[], map: any) {

  //   // ---------------------------------------------------
  //   // 1. Create NON-CLUSTERED layer for 50m circles
  //   // ---------------------------------------------------
  //   const circleFeatures = points.map((p, index) => {

  //     const center = fromLonLat([p.lon, p.lat]);

  //     // circle radius = 50m
  //     const circleGeom = new Circle(center, 50);

  //     const circleFeature = new Feature({
  //       geometry: circleGeom,
  //       id: p.id,
  //       color: index < 6500 ? 'red' : 'green'
  //     });

  //     return circleFeature;
  //   });

  //   const circleSource = new VectorSource({
  //     features: circleFeatures
  //   });

  //   const circleLayer = new VectorLayer({
  //     source: circleSource,
  //     style: (feature) => {
  //       const color = feature.get('color') === 'red'
  //         ? 'rgba(255,0,0,0.25)'
  //         : 'rgba(0,128,0,0.25)';

  //       const strokeColor = feature.get('color') === 'red'
  //         ? 'rgba(255,0,0,0.9)'
  //         : 'rgba(0,128,0,0.9)';

  //       return new Style({
  //         stroke: new Stroke({
  //           color: strokeColor,
  //           width: 2
  //         }),
  //         fill: new Fill({
  //           color: color
  //         })
  //       });
  //     }
  //   });

  //   circleLayer.setZIndex(5);
  //   map.addLayer(circleLayer);

  //   // ---------------------------------------------------
  //   // 2. Convert points → marker features
  //   // ---------------------------------------------------
  //   const markerFeatures = points.map((p, index) => {
  //     return new Feature({
  //       geometry: new Point(fromLonLat([p.lon, p.lat])),
  //       id: p.id,
  //       color: index < 6500 ? 'red' : 'green'
  //     });
  //   });

  //   const markerSource = new VectorSource({ features: markerFeatures });

  //   // ---------------------------------------------------
  //   // 3. Cluster Source for markers only
  //   // ---------------------------------------------------
  //   const clusterSource = new Cluster({
  //     distance: 40,
  //     source: markerSource
  //   });

  //   // ---------------------------------------------------
  //   // 4. Cluster layer styling
  //   // ---------------------------------------------------
  //   const clusterLayer = new VectorLayer({
  //     source: clusterSource,
  //     style: (feature) => {

  //       const size = feature.get('features').length;

  //       if (size === 1) {
  //         const item = feature.get('features')[0];

  //         const color = item.get('color') === 'red' ? '#ff0000' : '#008000';

  //         return new Style({
  //           image: new CircleStyle({
  //             radius: 5,
  //             fill: new Fill({ color }),
  //             stroke: new Stroke({ color: '#fff', width: 1 })
  //           })
  //         });
  //       }

  //       return new Style({
  //         image: new CircleStyle({
  //           radius: 14,
  //           fill: new Fill({ color: '#37474f' }),
  //           stroke: new Stroke({ color: '#fff', width: 2 })
  //         }),
  //         text: new Text({
  //           text: size.toString(),
  //           fill: new Fill({ color: '#fff' })
  //         })
  //       });
  //     }
  //   });

  //   clusterLayer.setZIndex(10);
  //   map.addLayer(clusterLayer);
  // }

  // loadPOCClusters(points: any[], map: any) {

  //   // ---------------------------------------------------
  //   // 1. Prepare marker features
  //   // ---------------------------------------------------
  //   const markerFeatures = points.map((p) => {
  //     return new Feature({
  //       geometry: new Point(fromLonLat([p.lon, p.lat])),
  //       name: p.name,
  //       region: p.region,
  //       id: p.id
  //     });
  //   });

  //   const markerSource = new VectorSource({
  //     features: markerFeatures
  //   });

  //   // ---------------------------------------------------
  //   // 2. Main Layer (ONLY MARKERS + NAME)
  //   // ---------------------------------------------------
  //   const markerLayer = new VectorLayer({
  //     source: markerSource,
  //     style: (feature) => {
  //       return new Style({
  //         image: new CircleStyle({
  //           radius: 5,
  //           fill: new Fill({ color: 'green' }),
  //           stroke: new Stroke({ color: '#fff', width: 1 })
  //         })
  //       });
  //     }
  //   });

  //   markerLayer.setZIndex(10);
  //   map.addLayer(markerLayer);

  //   // ---------------------------------------------------
  //   // 3. OPTIONAL: Only show labels when zoom > 14
  //   // ---------------------------------------------------
  //   map.on('moveend', () => {
  //     const zoom = map.getView().getZoom();

  //     markerLayer.setStyle((feature) => {
  //       return new Style({
  //         image: new CircleStyle({
  //           radius: 5,
  //           fill: new Fill({ color: 'green' }),
  //           stroke: new Stroke({ color: '#fff', width: 1 })
  //         }),
  //         text: zoom > 14
  //           ? new Text({
  //             text: feature.get('name'),
  //             font: '12px Calibri,sans-serif',
  //             fill: new Fill({ color: '#000' }),
  //             stroke: new Stroke({ color: '#fff', width: 3 }),
  //             offsetY: -15
  //           })
  //           : null
  //       });
  //     });
  //   });

  // }


  clearGeoZoneLayers(map: any) {
  const layersToRemove = [];

  map.getLayers().forEach((layer: any) => {
    if (layer && layer.get('layerType') === 'geozone') {
      layersToRemove.push(layer);
    }
  });

  layersToRemove.forEach(layer => map.removeLayer(layer));
}


  loadPOCClusters(points: any[], map: Map, labelElement: HTMLElement) {

    // -----------------------------------------
    // 1. Create marker features
    // -----------------------------------------
    const markerFeatures = points.map(p =>
      new Feature({
        geometry: new Point(fromLonLat([p.lon, p.lat])),
        name: p.name,
        region: p.region,
        id: p.id
      })
    );

    const markerSource = new VectorSource({ features: markerFeatures });

    // -----------------------------------------
    // 2. CLUSTER SOURCE
    // -----------------------------------------
    const clusterSource = new Cluster({
      distance: 40,      // adjust cluster radius
      source: markerSource
    });

    // -----------------------------------------
    // 3. CLUSTER LAYER
    // -----------------------------------------
    const clusterLayer = new VectorLayer({
      source: clusterSource,
      style: (feature) => {
        const size = feature.get('features').length;

        // If only 1 marker → show marker icon
        if (size === 1) {
          return new Style({
            image: new Icon({
              src: 'assets/vtstrackhisIcon/Idle.png',
              scale: 0.5,            // adjust icon size
              anchor: [0.5, 1]
            })
          });
        }

        // If multiple markers → show cluster bubble
        return new Style({
          image: new CircleStyle({
            radius: 14,
            fill: new Fill({ color: '#37474f' }),
            stroke: new Stroke({ color: '#fff', width: 2 })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({ color: '#fff' })
          })
        });
      }
    });

    clusterLayer.set('layerType', 'geozone');
    clusterLayer.setZIndex(5);
    map.addLayer(clusterLayer);
    // -----------------------------------------
    // 4. HTML POPUP OVERLAY
    // -----------------------------------------
    const labelOverlay = new Overlay({
      element: labelElement,
      positioning: 'bottom-center',
      offset: [0, -20],
      stopEvent: false
    });
    map.addOverlay(labelOverlay);

    // -----------------------------------------
    // 5. HOVER POPUP LOGIC
    // -----------------------------------------
    map.on('pointermove', (evt) => {
  const feature: any = map.forEachFeatureAtPixel(evt.pixel, f => f);

  if (!feature) {
    labelElement.style.display = 'none';
    return;
  }

  const items = feature.get('features');

  // ---------- SINGLE MARKER ----------
  if (items && items.length === 1) {
    const realMarker = items[0];

    const name = realMarker.get('name');  // geozone has name, vehicle does NOT

    if (!name || typeof name !== 'string') {
      // 🚫 no popup for vehicles
      labelElement.style.display = 'none';
      return;
    }

    // ✔ SHOW popup for geozone markers only
    labelElement.innerText = name;
    labelElement.style.display = 'block';
    labelOverlay.setPosition(evt.coordinate);
    return;
  }

  // hide for clusters
  labelElement.style.display = 'none';
});

  }








  circleGeoZone() {
    const feature: any = Object.values(this.map.getLayers().item(2).getSource().idIndex_)[0];
    const firstCoordinate = feature.getGeometry().getFirstCoordinate();
    const lastCoordinate = feature.getGeometry().getLastCoordinate();
    const firstLatLng = toLonLat([firstCoordinate[0], firstCoordinate[1]]);
    const lastLatLng = toLonLat([lastCoordinate[0], lastCoordinate[1]]);
    const geofence = firstLatLng[1] + ',' + firstLatLng[0] + '|' + lastLatLng[1] + ',' + lastLatLng[0];
    return geofence;
  }

  setToPolygon(map: any, type: string, selectValue: string) {
    var color = "1eb15d"
    if (selectValue == "Restricted") {
      color = 'FF0000'
    }
    this.polyLine = new Draw({
      source: map.getLayers().item(2).getSource(),
      type: type,
      style: new Style({
        fill: new Fill({
          color: '#' + color + '50'
        }),
        stroke: new Stroke({
          color: '#' + color,
          width: 3
        })
      })
    });
    var thisLocally = this
    this.polyLine.on('drawend', function (event) {
      var latLng = event.feature.getGeometry().getCoordinates();
      map.removeInteraction(thisLocally.polyLine);
    })
    map.addInteraction(this.polyLine);

    let dragPolygonInteraction = new Modify(
      {
        source: map.getLayers().item(2)
          .getSource()
      });

    map.addInteraction(dragPolygonInteraction);
  }
  getPolygonCoordinates(map: any) {
    let latLngArray = [];
    let newLatLngAry = []
    const feature = map.getLayers().item(2).getSource().getFeatures();
    feature.forEach(function (feature) {
      var featureArray = feature.getGeometry().getCoordinates();
      latLngArray = featureArray.length <= 1 ? featureArray[0] : featureArray;
    });
    for (let i = 0; i < latLngArray.length - 1; i++) {
      let firstCoordinate = toLonLat(latLngArray[i]);
      newLatLngAry.push(firstCoordinate[1] + "," + firstCoordinate[0]);
    }
    return newLatLngAry;
  }

  getRoadFromCoordinate(map: any) {
    let latLngArray = [];
    let newLatLngAry = []
    const feature = map.getLayers().item(2).getSource().getFeatures();
    feature.forEach(function (feature) {
      var featureArray = feature.getGeometry().getCoordinates();
      latLngArray = featureArray;
    });
    for (let i = 0; i < latLngArray.length; i++) {
      let firstCoordinate = toLonLat(latLngArray[i]);
      newLatLngAry.push(firstCoordinate[1] + "," + firstCoordinate[0]);
    }
    return newLatLngAry;
  }

  polyLineClear(map) {
    if (this.polyLine)
      map.removeInteraction(this.polyLine);
  }

  setPolyLine(map: any, latLng) {
    let points = [];
    for (var i = 0; i < latLng.length; i++) {
      points.push(transform([parseFloat(latLng[i]['longitude']), parseFloat(latLng[i]['latitude'])], 'EPSG:4326', 'EPSG:3857'));
    }
    let thing = new Polygon([points]);
    var styles = new Style({
      stroke: new Stroke({
        color: '#32384b',
        width: 3
      })
    });

    var featurething = new olFeature({
      name: "PolyString",
      geometry: thing
    });
    featurething.setStyle(styles);

    map.getLayers().item(2).getSource().addFeature(featurething);
    this.fitBounds(map, 2)
  }

  setRoadLineString(map, coordinates) {
    var points = [];
    for (var i = 0; i < coordinates.length; i++) {
      points.push(transform([parseFloat(coordinates[i]['longitude']), parseFloat(coordinates[i]['latitude'])], 'EPSG:4326', 'EPSG:3857'));
    }
    var thing = new LineString(points);
    var styles = new Style({
      stroke: new Stroke({
        color: 'green',
        width: 3
      })
    });
    var featurething = new olFeature({
      name: "lineString",
      geometry: thing
    });
    featurething.setStyle(styles);
    map.getLayers().item(2).getSource().addFeature(featurething);
    this.fitBounds(map, 2);
  }
}
